import cost from '@/api/product/cost'

import { baseState, baseMutations } from '@/store/mixins'

import { mapKeys, camelCase, join } from 'lodash'

class SparePartPagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  serial_list_sn_status_id: [1, 3], // 1/ in-storage/ 3 available for sale
  serial_list_location: undefined, // location
  spare_list_location: undefined, // location
  sparePartPagination: new SparePartPagination(),
  sparePartResources: [],
  spare_search: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SEARCH_SPARE(state, value) {
    state.spare_search = value
  },
  SET_SERIAL_LIST_SN_STATUS(state, value) {
    state.serial_list_sn_status_id = value
  },
  SET_SERIAL_LIST_LOCATION(state, value) {
    state.serial_list_location = value
  },
  SET_SPARE_LIST_LOCATION(state, value) {
    state.spare_list_location = value
  },
  RECEIVE_RESOURCES_SPARE_PART(state, { data, ...meta }) {
    state.sparePartResources = []
    data.forEach(resource => {
      state.sparePartResources.push(
        Object.assign(resource, { _deleting: false })
      )
    })
    state.sparePartPagination = new SparePartPagination(
      mapKeys(meta.meta, (v, k) => camelCase(k))
    )
  }
}

export const actions = {
  fetchSerial(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        location: context.state.serial_list_location,
        filter: {
          search: context.state.search,
          sn_status_id:
            context.state.serial_list_sn_status_id.length > 0
              ? join(context.state.serial_list_sn_status_id, ',')
              : '1,3'
        }
      },
      attrubutes
    )
    return cost.getListSerial({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  fetchSparePart(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        location: context.state.spare_list_location,
        filter: {
          search: context.state.spare_search
        }
      },
      attrubutes
    )
    return cost.getListSparePart({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_SPARE_PART', response)
      return Promise.resolve(response)
    })
  },
  getFormModel(context, attributes = {}) {
    return cost.formModel({ params: attributes })
  },
  serialToExcel(context) {
    return cost.serialToExcel({
      location_id: context.state.serial_list_location,
      sn_status_id: context.state.serial_list_sn_status_id
    })
  },
  sparePartToExcel(context) {
    return cost.sparePartToExcel({
      location_id: undefined
    })
  }
}
